import { AppBar, Grid, makeStyles, Tab, Tabs } from '@material-ui/core';
import i18n from 'i18n';
import { EnvironmentFields } from 'modules/environments/interfaces';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props {
  environment: EnvironmentFields | null;
  current:
    | 'instances'
    | 'servers'
    | 'configuration'
    | 'history'
    | 'maintenance'
    | 'image';
}

const NavBarEnvironments = ({ current, environment }: Props) => {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const isMulticloud =
    environment && environment.provider.type === 'multicloud';

  const hiddenImages = (
    provider: string | undefined,
    behavior: string | undefined
  ) => {
    return provider === 'multicloud' || behavior === 'micro';
  };

  const items = [
    { label: i18n.t('INSTANCES_KEY'), slug: 'instances' },
    {
      label: i18n.t('SERVERS_KEY'),
      slug: 'servers',
      hidden: isMulticloud,
    },
    { label: i18n.t('SETTINGS_KEY'), slug: 'configuration' },
    {
      label: i18n.t('IMAGES_KEY'),
      slug: 'image',
      hidden: hiddenImages(
        environment?.provider.type,
        environment?.behavior.type
      ),
    },
    { label: i18n.t('HISTORY_SOP_KEY'), slug: 'history' },
    { label: i18n.t('MAINTENANCE_KEY'), slug: 'maintenance' },
    {
      label: i18n.t('LOGS_PAGE.LIST_LOGS_TITLE_KEY'),
      slug: 'audit',
    },
  ];

  return (
    <Grid item xs={12} className={classes.rootBar}>
      <AppBar position="static" color="default" className={classes.bar}>
        <Tabs
          value={items
            .filter(item => !item?.hidden)
            .findIndex(item => item.slug === current)}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {items
            .filter(item => !item?.hidden)
            .map(({ label, slug }) => (
              <Tab
                id={`navbar-${slug}`}
                key={slug}
                label={label}
                className={classes.tab}
                onClick={() => history.push(`/environments/${id}/${slug}`)}
              />
            ))}
        </Tabs>
      </AppBar>
    </Grid>
  );
};

export default NavBarEnvironments;
